import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  isMuted: true
};
const videoSoundSlice = createSlice({
  name: 'videoSound',
  initialState,
  reducers: {
    muteAll(state) {
      state.isMuted = true;
    },
    unmuteAll(state) {
      state.isMuted = false;
    },
    toggleMute(state) {
      state.isMuted = !state.isMuted;
    }
  }
});
export const { muteAll, unmuteAll, toggleMute } = videoSoundSlice.actions;
export default videoSoundSlice.reducer;
